import { render, staticRenderFns } from "./faqs-afiliados.vue?vue&type=template&id=a184f9dc&lang=html"
import script from "./faqs-afiliados.vue?vue&type=script&lang=js"
export * from "./faqs-afiliados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports